module.exports = __webpack_public_path__ + "static/losing-baad2ca967e715ae6f4e9207471343f3.mp3";